<template>
    <div class="b-item">
        <a class="b-item__img" :class="{'filled': item.PREVIEW_PICTURE}" :href="item.DETAIL_PAGE_URL">
            <img :src="item.PREVIEW_PICTURE ? item.PREVIEW_PICTURE.src : ''" :alt="item.NAME ? item.NAME : 'Изображение'" loading="lazy">
        </a>
        <div class="b-item__text">
            <a class="b-item__title" :href="item.DETAIL_PAGE_URL">{{ item.NAME }}</a>
<!--            <div v-if="item.EASY_CLEAN === 'Y'" class="b-item__checkbox">-->
<!--                <div class="default-checkbox">-->
<!--                    <input class="default-checkbox__input" @change="setEasyClean" :disabled="item.EASY_CLEAN_DEFAULT === 'Y'"-->
<!--                           v-model="easy_clean" type="checkbox" name="id" :id="item.bid">-->
<!--                    <label class="default-checkbox__label" :for="item.bid">{{ moduleEasyClean.name }}</label>-->
<!--                </div>-->
<!--            </div>-->
            <div class="b-item__price">
                <div class="b-item__price-current">
                    <animated-number :number="Number(item.CURRENT_PRICE_EC)"></animated-number>
                </div>
                <div v-if="item.DEFAULT_PRICE_EC > item.CURRENT_PRICE_EC" class="b-item__price-old">
                    <animated-number :number="Number(item.DEFAULT_PRICE_EC)"></animated-number>
                </div>
            </div>
        </div>

        <div class="b-item__quantity">
            <basket-buttons :amount="item.QUANTITY" :bid="item.bid"></basket-buttons>
        </div>
        <basket-del-btn :bid="item.bid"></basket-del-btn>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import BasketButtons from "@/components/Basket/BasketButtons";
import BasketDelBtn from "@/components/Basket/BasketDelBtn";
import tools from "@/components/mixins/tools";
import AnimatedNumber from "@/components/Animation/AnimatedNumber";

export default {
    name      : "BasketItem",
    components: {BasketButtons, BasketDelBtn, AnimatedNumber},
    mixins    : [tools],
    props     : ['item'],
    computed  : {
        ... mapState([
            'moduleBasket',
          // 'moduleEasyClean'
        ]),
    },
    data() {
        return {
            // easy_clean: false,
            bid       : this.item.bid
        }
    },
    // created() {
    //     this.easy_clean = this.item.PLUS_EASY_CLEAN === 'Y' || this.item.EASY_CLEAN_DEFAULT === 'Y';
    // },
    // methods: {
    //     ... mapActions([
    //         'SET_EASY_CLEAN'
    //     ]),
    //     setEasyClean() {
    //         let context = this;
    //         this.debounce(function() {
    //             context.SET_EASY_CLEAN(context, {bid: context.bid, easy_clean: context.easy_clean});
    //         }, 1000);
    //     }
    // }
}
</script>

<style scoped>

</style>